(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodCollapsible', sodCollapsible);

    function sodCollapsible() {
        return {
            restrict: 'A',
            scope: {
                clickTarget: '@',
                hideTarget: '@',
                showOnDefault: '@?',
                hideOthers: '@?',
                icon: '@?',
                closeDirection: '@?',
                hideLabel: '@?',
                showLabel: '@?',
                label: '@?',
                iconOp: '@?',
                iconCl: '@?'
            },
            link: sodCollapsibleLink
        };

        function sodCollapsibleLink(scope, elem, attr) {
            var elemUniqueId = attr.id || scope.$id;
            elem.addClass('collapsible-' + elemUniqueId);
            var clickTargetElem = elem.find(scope.clickTarget);
            var hideTargetElem = elem.find(scope.hideTarget);
            if (hideTargetElem.length === 0) {
                hideTargetElem = $('.collapsible-' + elemUniqueId + " " + scope.clickTarget);
            }
            var parent = elem.parent();
            var relatedClickTargets = parent.find(scope.clickTarget);

            // default values
            var showOnDefault = scope.showOnDefault ? (scope.showOnDefault == 'yes') : true;
            var hideOthers = scope.hideOthers ? (scope.hideOthers == 'yes') : false;
            var iconClosed = '';
            var iconOpened = '';

            // values for minus and plus
            if(!scope.iconOp){
                if (!scope.closeDirection) {
                    scope.closeDirection = '-right';
                } else {
                    scope.closeDirection = '-' + scope.closeDirection;
                }
                iconClosed = scope.icon ? 'fa-' + scope.icon + scope.closeDirection : '';
                iconOpened = scope.icon ? 'fa-' + scope.icon + '-down' : '';
            }else{
                iconClosed = scope.iconCl ? 'fa-' + scope.iconCl : '';
                iconOpened = scope.iconOp ? 'fa-' + scope.iconOp : '';
            }

            if (scope.icon) {
                elem.addClass('collapsible-has-icon');
            }

            if (scope.iconOp && scope.iconCl) {
                elem.addClass('collapsible-has-icon-open-close');
            }

            var filteredAllText     = null
            var filteredHalfText    = null
            if(hideTargetElem.length > 0){
                filteredAllText     = hideTargetElem.filter('.all-text')
                filteredHalfText    = hideTargetElem.filter('.half-text')
            }

            if (!showOnDefault) {
                hideTargetElem.hide();
                if(filteredAllText){
                    filteredHalfText.hide();
                }
                if(filteredHalfText){
                    filteredHalfText.show();
                }
                clickTargetElem.addClass('collapsible-is-hidden');
                manageToggleable(false, clickTargetElem);
            } else {
                if(filteredAllText){
                    filteredHalfText.show();
                }
                if(filteredHalfText){
                    filteredHalfText.hide();
                }
                elem.addClass('active');
                manageToggleable(true, clickTargetElem);
            }
            clickTargetElem.on('click', function () {
                if (hideOthers) {
                    var others = parent.find('[sod-collapsible]:not(.collapsible-' + elemUniqueId + ')');
                    others.find(scope.hideTarget).hide();
                    others.find(scope.clickTarget).addClass('collapsible-is-hidden');
                    others.removeClass('active');
                    manageToggleable(false);
                }
                if (!clickTargetElem.hasClass('collapsible-is-hidden')) {
                    hideTargetElem.slideUp(150);
                    clickTargetElem.addClass('collapsible-is-hidden');
                    if (!hideOthers) {
                        elem.removeClass('active');
                    }
                    if(filteredAllText){
                        filteredAllText.hide();
                    }
                    if(filteredHalfText){
                        filteredHalfText.show();
                    }
                    manageToggleable(false, clickTargetElem);
                } else {
                    hideTargetElem.slideDown(150);
                    clickTargetElem.removeClass('collapsible-is-hidden');
                    elem.addClass('active');
                    if(filteredAllText){
                        filteredAllText.show();
                    }
                    if(filteredHalfText){
                        filteredHalfText.hide();
                    }
                    manageToggleable(true, clickTargetElem);
                }
            });

            function manageToggleable(state, target) {
                const currentTarget = (!target) ? relatedClickTargets : target;
                const label = currentTarget.find(scope.label);
                if (!state) {
                    label ? label.first().text(scope.showLabel) : null;
                    currentTarget.find('.fa').removeClass(iconOpened).addClass(iconClosed);
                } else {
                    label ? label.first().text(scope.hideLabel) : null;
                    currentTarget.find('.fa').removeClass(iconClosed).addClass(iconOpened);
                }
            }
        }
    }
})();